"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchCrossellModule = exports.CROSSELL_MODULE_URL = void 0;
// Mapper
const mapper_1 = require("./mapper");
exports.CROSSELL_MODULE_URL = `${window.MIDDLEWARE_BASE_HOST}/mb-api-comm-offers`;
const fetchCrossellModule = (API, { section, version = 'v2', propositionAreaId = 'crossell', interstitialType = 'commercial' }, tracker, crossellConfig) => {
    const url = `${exports.CROSSELL_MODULE_URL}/${version}/proposition-areas/${propositionAreaId}?section=${section}&interstitialType=${interstitialType}&addVisualizations=true`;
    return API.GET(url).then(response => (0, mapper_1.mapCrossellModuleData)(response?.data?.propositions ?? [], tracker, crossellConfig));
};
exports.fetchCrossellModule = fetchCrossellModule;
const crossellModuleRepository = {
    fetchCrossellModule: exports.fetchCrossellModule,
};
exports.default = crossellModuleRepository;
//# sourceMappingURL=repository.js.map